<template>
    <slot>
        <div class="mb-1">
            <label class="form-label" for="paymentMode">Mode of Payment</label>
            <v-select
                placeholder="Select Cash & Bank Account"
                class="w-100"
                v-model="formData.mop_account_head_id"
                name="mop_account_head_id"
                :options="cashAndBank"
                label="name"
                :reduce="name => name.id"
                :disabled="invoiceId"
            />
        </div>
    </slot>
</template>

<script setup>
import { inject, computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const invoiceId = computed(() => route.params.invoiceId)

const formData = inject('formData')
const props = defineProps({
    grandTotal: {
        type: Number
    },
    cashAndBank: {
        type: Array
    }
})

</script>

<style scoped>
.font-20 {
    font-size: 20px;
}
</style>